require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-nicola-navone-fare-fino-in-fondo-il-proprio-mestiere-architettura-recente-nel-cantone-ticino-bari-28-novembre-2019.json") })
        }
      }, "path---relazioni-e-conferenze-nicola-navone-fare-fino-in-fondo-il-proprio-mestiere-architettura-recente-nel-cantone-ticino-bari-28-novembre-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-nicola-navone-fare-fino-in-fondo-il-proprio-mestiere-architettura-recente-nel-cantone-ticino-bari-28-novembre-2019!./.cache/json/relazioni-e-conferenze-nicola-navone-fare-fino-in-fondo-il-proprio-mestiere-architettura-recente-nel-cantone-ticino-bari-28-novembre-2019.json
// module id = 726
// module chunks = 231608221292675